import { useCore } from '@/composables/core/index.js'
import { ENDPOINTS } from '@/lib/consts.js'
import { computed } from 'vue'
import { useLogger, useReadyTrigger } from '@booksy-com/vue-tools'

let chatProvider = null

const logger = useLogger('chat')

let readyTrigger = null

const _logUninitializedError = (e) => {
  logger.error('chat provider not initialized')
  if (e) {
    logger.error(e)
  }
}

const _handleChatAction = (method, options) => {
  if (!readyTrigger) {
    _logUninitializedError()
    return
  }

  return readyTrigger.promise.then(() => {
    if (chatProvider?.[method]) {
      chatProvider[method](options)
    } else {
      _logUninitializedError()
    }
  }).catch((e) => {
    _logUninitializedError(e)
  })
}

const open = async (options) => _handleChatAction('open', options)
const close = async () => _handleChatAction('close')
const toggle = async () => _handleChatAction('toggle')

export const createChat = async () => {
  readyTrigger = useReadyTrigger()

  const { apiCall, store } = useCore()
  const business = computed(() => store.state.business)

  const setupChatProvider = async () => {
    if (!business.value.business?.id) {
      return
    }

    try {
      const data = await apiCall({
        method: 'POST',
        url: ENDPOINTS.ZOWIE_JWT,
        data: {
          business_id: business.value.business.id,
        },
        params: {
          new_zowie: 1,
        },
      })

      return import('@/composables/chat/providers/zowie/index.js').then(Zowie => {
        Zowie.createZowie({ data: data.data })
        chatProvider = Zowie.useZowie()
        readyTrigger.resolveTrigger()
      })
    } catch (e) {
      logger.error(e)
      readyTrigger.rejectTrigger()
    }
  }

  return setupChatProvider()
}

export const destroyChat = async () => {
  return _handleChatAction('logout').then(() => { chatProvider = readyTrigger = null })
}

export const useChat = () => ({
  open,
  close,
  toggle,
})
